import {NgModule} from '@angular/core';

import {SharedModule} from '@shared/shared.module';
import {HelpDrawerComponent} from './help-drawer/help-drawer.component';
import {NzDrawerModule} from 'ng-zorro-antd/drawer';
import {SetupComponent} from '@shared/components/setup/setup.component';
import {NzStepsModule} from 'ng-zorro-antd/steps';
import {SummaryDrawerComponent} from '@modules/view-report/components/summary-drawer/summary-drawer.component';
import {VinRecallComponent} from '@modules/view-report/components/vin-recall/vin-recall.component';
import {NzListModule} from 'ng-zorro-antd/list';
import {NzResultModule} from 'ng-zorro-antd/result';
import {NzTableModule} from 'ng-zorro-antd/table';
import {CarInventoryCardComponent} from './car-inventory-card/car-inventory-card.component';
import {NzCarouselModule} from 'ng-zorro-antd/carousel';
import {NzImageModule} from 'ng-zorro-antd/image';
import {NoDataPlaceholderComponent} from './no-data-placeholder/no-data-placeholder.component';
import {NzDescriptionsModule} from 'ng-zorro-antd/descriptions';
import {NzDividerModule} from 'ng-zorro-antd/divider';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {BlogSummaryCardComponent} from '@shared/components/blog/blog-summary-card/blog-summary-card.component';
import {MomentModule} from 'ngx-moment';
import {ShareModalComponent} from './share-modal/share-modal.component';
import {NzAlertModule} from 'ng-zorro-antd/alert';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {PayReportModalComponent} from './pay-report-modal/pay-report-modal.component';
import {CarInventoryLongCardComponent} from './car-inventory-long-card/car-inventory-long-card.component';
import {ReportCardComponent} from '@shared/components/report-card/report-card.component';
import {UpdateReportComponent} from '@shared/components/update-report/update-report.component';
import {
  ExploreListingsFilterComponent
} from '@shared/components/explore-listings-filter/explore-listings-filter.component';
import {NzSliderModule} from 'ng-zorro-antd/slider';
import {NzCollapseModule} from 'ng-zorro-antd/collapse';
import {NzSwitchModule} from 'ng-zorro-antd/switch';
import {NzCheckboxModule} from 'ng-zorro-antd/checkbox';
import {LoanCalculatorComponent} from '@shared/components/loan-calculator/loan-calculator.component';
import {FuelInfoComponent} from '@shared/components/fuel-info/fuel-info.component';
import {SwiperModule} from 'swiper/angular';
import {NgApexchartsModule} from 'ng-apexcharts';
import {PriceRangeBarChartComponent} from '@shared/components/price-range-bar-chart/price-range-bar-chart.component';
import {DataLoadingComponent} from '@shared/components/data-loading/data-loading.component';
import {CarListingExtrasComponent} from '@shared/components/car-listing-extras/car-listing-extras.component';
import {NzTagModule} from 'ng-zorro-antd/tag';
import {AddFabButtonComponent} from '@shared/components/add-fab-button/add-fab-button.component';
import {MatIconModule} from '@angular/material/icon';
import {AiChatCardComponent} from '@shared/components/ai-chat-card/ai-chat-card.component';
import {NzSegmentedModule} from 'ng-zorro-antd/segmented';
import {NgOptimizedImage} from '@angular/common';
import {NzPopconfirmModule} from 'ng-zorro-antd/popconfirm';

@NgModule({
  // entryComponents: [HelpDrawerComponent, SetupComponent, SummaryDrawerComponent, ReportCardComponent,
  //   VinRecallComponent, ShareModalComponent, PayReportModalComponent, PageNotFoundComponent, UpdateReportComponent],
  declarations: [
    HelpDrawerComponent, SetupComponent, SummaryDrawerComponent, VinRecallComponent, ReportCardComponent,
    CarInventoryCardComponent, NoDataPlaceholderComponent, PageNotFoundComponent, BlogSummaryCardComponent,
    ShareModalComponent, PayReportModalComponent, CarInventoryLongCardComponent, UpdateReportComponent,
    ExploreListingsFilterComponent, LoanCalculatorComponent, FuelInfoComponent, PriceRangeBarChartComponent,
    DataLoadingComponent, CarListingExtrasComponent, AddFabButtonComponent, AiChatCardComponent
  ],
  exports: [
    CarInventoryCardComponent,
    NoDataPlaceholderComponent,
    BlogSummaryCardComponent,
    CarInventoryLongCardComponent,
    ReportCardComponent,
    ExploreListingsFilterComponent,
    LoanCalculatorComponent,
    FuelInfoComponent,
    PriceRangeBarChartComponent,
    DataLoadingComponent,
    CarListingExtrasComponent,
    AddFabButtonComponent,
    AiChatCardComponent
  ],
  imports: [
    SharedModule,
    NzDrawerModule,
    NzStepsModule,
    NzListModule,
    NzResultModule,
    NzTableModule,
    NzCarouselModule,
    NzImageModule,
    NzDescriptionsModule,
    NzDividerModule,
    MomentModule,
    NzAlertModule,
    FontAwesomeModule,
    NzSliderModule,
    NzCollapseModule,
    NzSwitchModule,
    NzCheckboxModule,
    SwiperModule,
    NgApexchartsModule,
    NzTagModule,
    MatIconModule,
    NzSegmentedModule,
    NgOptimizedImage,
    NzPopconfirmModule
  ]
})
export class SharedComponentsModule {
}
